import toNumber from './toNumber.js';

function toInteger(value) {
    var result = toNumber(value);
    if (!result || result === Infinity || result === -Infinity) {
        return result === result ? result : 0;
    }
    var remainder = result % 1;
    return remainder ? result - remainder : result;
}

export { toInteger as default };
